import styled from 'styled-components';
import { space } from 'styled-system';

const Wrapper = styled.div`
  ${space}
  max-width: ${(props) => props.maxWidth || '800px'};
`;

export default Wrapper;
